import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";

import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";

import GalleryPart from "../../common pages/gallery/GalleryPart";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import { fetchData } from "../../../utils/fetchData";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";

const SOAGallery = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.gallery, setData);
  }, []);
  console.log("testing55.........", data);
  return (
    <React.Fragment>
      <Helmet>
        <title>Gallery - {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />

      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Gallery"
          pageName="Gallery"
          breadcrumbsClass="breadcrumb-bg"
        />
        {getMenu()}

        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3 style={{ marginBottom: "20px" }} title="Gallery">
                      Gallery
                    </h3>
                    {data.data?.map((obj) => (
                      <>
                        <h3 title={obj?.attributes?.Images_Category}>
                          {obj?.attributes?.Images_Category}
                        </h3>
                        <GalleryPart
                          title={""}
                          images={obj?.attributes?.Images || []}
                        />
                      </>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default SOAGallery;
